"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const auth_social_account_api_1 = require("../../services/auth-social-account-api");
const useGoogleCredential = ({ scope, onSuccess, onError, }) => {
    const onSuccessRef = (0, react_1.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, react_1.useRef)(onError);
    onErrorRef.current = onError;
    const handleRedirect = (url) => {
        window.location.assign(url);
    };
    const submitCredential = async (credential, navigation) => {
        try {
            const res = await auth_social_account_api_1.AuthSocialAccountApi.initGoogleAccount(navigation, credential, scope);
            return { hasError: false, url: res.link };
        }
        catch (error) {
            if (window.newrelic) {
                window.newrelic.noticeError(new Error('Failed to submit JWT to social api'), {
                    message: error.message,
                    status: error.response?.status,
                });
            }
            return { hasError: true, url: '' };
        }
    };
    const handleSubmit = async (credential, navigation) => {
        const { hasError, url, error } = await submitCredential(credential, navigation);
        if (hasError) {
            onErrorRef.current?.(error);
            return;
        }
        onSuccessRef.current?.();
        handleRedirect(url);
    };
    return { handleSubmit, submitCredential };
};
exports.default = useGoogleCredential;
